<prism-layout [navOpen]="!isSmallDevice() && (oktaIntf.$isUserAuthenticated | async) === true" *transloco="let t">
	<!-- Nav -->
	<prism-nav slot="nav">
		<sh-switch-organization-main></sh-switch-organization-main>
		<sh-side-nav [hasSecondaryNav]="true"></sh-side-nav>
	</prism-nav>
	<prism-nav slot="secondary-nav" secondary accent>
		<sh-secondary-nav
			navTitleTranslationKey="cloud.shared.application-names.cloud-device-management"
			[navItems]="secondaryNavListItems()"
			[hasSecondaryNavButton]="false"
		></sh-secondary-nav>
	</prism-nav>

	<!-- Toolbar -->
	@if ((oktaIntf.$isUserAuthenticated | async) === true) {
		<sh-header-toolbar
			slot="toolbar"
			[showSidenavToggleButton]="false"
			[showFeatureButton]="!breakpointService.isLteXSmall()"
			[showNotifications]="showNotifications"
			(signOut)="sendSignOutAnalyticsEvent()"
		></sh-header-toolbar>
	}

	<div class="sh-main-content">
		@defer {
			<!-- Main content -->
			<router-outlet></router-outlet>
		}
	</div>

	<sh-footer slot="footer"></sh-footer>
</prism-layout>
